import * as React from 'react'
import {
  List,
  TextField,
  Datagrid,
  NumberField,
  TextInput,
  useGetIdentity,
  TopToolbar,
  FilterButton,
  ExportButton,
  CreateButton,
  EditButton,
  DeleteWithConfirmButton,
  ReferenceField,
  FunctionField,
} from 'react-admin'
import { useTranslate } from 'ra-core'
import { MyPagination } from '../../MyPagination'
import StatusChip from '../../components/StatusChip'
import TruncatedTextCell from '../../components/TruncatedTextCell'

const FilesFilters = [<TextInput key="campaign_id" source="campaign_id" />]

const WsCampaignsListActions = () => {
  const translate = useTranslate()
  return (
    <TopToolbar>
      <CreateButton label={translate('surveys.actions.new_wscampaign')} />
      <FilterButton />
      <ExportButton />
    </TopToolbar>
  )
}

const WsCampaignList = props => {
  const translate = useTranslate()
  const { loading: identityLoading } = useGetIdentity()
  if (identityLoading) return <>Loading...</>
  return (
    <List
      {...props}
      className="wscampaign-list"
      actions={<WsCampaignsListActions />}
      bulkActionButtons={false}
      sort={{ field: 'id', order: 'DESC' }}
      filters={FilesFilters}
      pagination={<MyPagination />}
    >
      <Datagrid>
        <NumberField source="id" sortByOrder="DESC" />
        <ReferenceField
          label={translate('surveys.resources.campaign')}
          source="campaign_id"
          reference="campaigns"
          link="show"
        >
          <TextField source="name" />
        </ReferenceField>
        <FunctionField
          label="URL WS"
          render={record => <TruncatedTextCell value={record.url_ws} />}
        />
        <FunctionField
          label={translate('surveys.common.status')}
          render={record => (
            <StatusChip
              value={record.status}
              activeLabel={translate('surveys.common.active')}
              inactiveLabel={translate('surveys.common.desactive')}
            />
          )}
        />
        <EditButton />
        <DeleteWithConfirmButton cancel="Cancel" undoable={true} />
      </Datagrid>
    </List>
  )
}

export default WsCampaignList
